import { render, staticRenderFns } from "./ClientAdministrationPdfTemplates.vue?vue&type=template&id=9dcf925e&scoped=true&"
import script from "./ClientAdministrationPdfTemplates.vue?vue&type=script&lang=ts&"
export * from "./ClientAdministrationPdfTemplates.vue?vue&type=script&lang=ts&"
import style0 from "./ClientAdministrationPdfTemplates.vue?vue&type=style&index=0&id=9dcf925e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcf925e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VChip,VCol,VDivider,VHover,VIcon,VRow,VSpacer,VTextField,VTooltip})
